/* Optional local-browser reading. No requests, storage, default voice or autoplay. */
(() => {
  'use strict';
  document.querySelectorAll('[data-v15-audio]').forEach((root) => {
    if (root.dataset.v15Ready) return;
    const controls = root.querySelector('[data-v12-audio-controls]');
    const play = root.querySelector('[data-v12-audio-play]');
    const pause = root.querySelector('[data-v12-audio-pause]');
    const stop = root.querySelector('[data-v12-audio-stop]');
    const status = root.querySelector('[data-v12-audio-status]');
    const answer = root.closest('#quick-answer');
    const title = answer && answer.querySelector('#quick-answer-title');
    const text = answer && answer.querySelector('[data-v12-answer-text]');
    if (!controls || !play || !pause || !stop || !status || !title || !text || text.tagName !== 'P') return;
    let words;
    try { words = JSON.parse(root.dataset.v12AudioTexts); } catch (_) { return; }
    const language = root.dataset.v12Language;
    if (!['lt', 'en', 'pl', 'de'].includes(language)) return;
    const synth = window.speechSynthesis;
    const Utterance = window.SpeechSynthesisUtterance;
    if (!synth || typeof synth.getVoices !== 'function' || typeof Utterance !== 'function') return;
    let active = null;
    let serial = 0;
    let state = 'idle';
    const voices = () => {
      try {
        return synth.getVoices().filter((candidate) => candidate.localService === true
          && String(candidate.lang).toLowerCase().split(/[-_]/)[0] === language);
      } catch (_) { return []; }
    };
    const render = (message) => {
      const available = voices().length > 0;
      if (!available) root.open = false;
      root.hidden = !available;
      controls.hidden = !available;
      play.disabled = Boolean(active) || !available;
      pause.disabled = !active;
      stop.disabled = !active;
      pause.textContent = state === 'paused' ? words.resume : words.pause;
      pause.setAttribute('aria-pressed', String(state === 'paused'));
      status.textContent = available ? message : '';
    };
    const finish = (message) => { active = null; state = 'idle'; render(message); };
    const cancel = (message) => {
      const wasActive = Boolean(active);
      serial += 1;
      active = null;
      state = 'idle';
      if (wasActive) synth.cancel();
      render(message);
    };
    play.addEventListener('click', () => {
      const selected = voices()[0];
      if (!selected) { cancel(''); return; }
      const transcript = title.textContent.trim() + '\n' + text.textContent.trim();
      if (!text.textContent.trim()) { render(words.audio_error); return; }
      serial += 1;
      const current = serial;
      synth.cancel();
      if (synth.paused) synth.resume();
      const utterance = new Utterance(transcript);
      utterance.voice = selected;
      utterance.lang = selected.lang;
      active = utterance;
      state = 'playing';
      utterance.onstart = () => { if (current === serial) render(words.audio_speaking); };
      utterance.onend = () => { if (current === serial) finish(words.audio_done); };
      utterance.onerror = () => { if (current === serial) finish(words.audio_error); };
      render(words.audio_speaking);
      try { synth.speak(utterance); } catch (_) { if (current === serial) finish(words.audio_error); }
    });
    pause.addEventListener('click', () => {
      if (!active) return;
      if (state === 'paused') {
        synth.resume(); state = 'playing'; render(words.audio_speaking);
      } else {
        synth.pause(); state = 'paused'; render(words.audio_paused);
      }
    });
    stop.addEventListener('click', () => cancel(words.audio_stopped));
    root.addEventListener('toggle', () => {
      if (!root.open && active) cancel(words.audio_stopped);
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && active) cancel(words.audio_stopped);
    });
    window.addEventListener('pagehide', () => { if (active) cancel(words.audio_stopped); });
    if (typeof synth.addEventListener === 'function') {
      synth.addEventListener('voiceschanged', () => {
        const available = voices();
        if (active && !available.some((candidate) => candidate.voiceURI === active.voice.voiceURI
          && candidate.lang === active.voice.lang)) cancel(words.audio_stopped);
        else render(active ? (state === 'paused' ? words.audio_paused : words.audio_speaking) : words.audio_ready);
      });
    }
    root.dataset.v15Ready = 'true';
    render(words.audio_ready);
  });
})();
